export default "__VITE_ASSET__BUsWehJ1__"